// extracted by mini-css-extract-plugin
module.exports = {"icon":"select_icon_uSVlP","actions":"select_actions_10J-U"};